import { formatDistanceToNow, isValid } from 'date-fns';

const getDateTimeAgo = (updatedOn) => {
  const dt = new Date(updatedOn);
  if (!updatedOn || !isValid(dt)) {
    return undefined;
  }
  let outputTimeAgo = formatDistanceToNow(new Date(updatedOn));
  outputTimeAgo = outputTimeAgo
    .replace('about', '~') //
    .replace('less than', '<') //
    .replace('greater than', '>'); //
  return `${outputTimeAgo} ago`;
};

export default getDateTimeAgo;
